import { Container } from 'hypo-container';
import { IAppConfig, root } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { ConfigMangerApiSdk } from '../api/ConfigMangerApiSdk';
import { ServiceBusController } from './ServiceBusController';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import serviceNames, { ConfigManagerService } from './ConfigManagerService';
import { ServiceStartedUseCase } from '../internal/use-cases/ServiceStartedUseCase';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

diContainer
    .register(serviceNames.httpTransport, () => root.HttpTransport)
    .register(
        serviceNames.configManagerApiSdk,
        (c) => new ConfigMangerApiSdk({ httpTransport: c.get(serviceNames.httpTransport) })
    )
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(
        serviceNames.serviceBusController,
        (c) => new ServiceBusController(c.get(serviceNames.configRepository))
    )
    .register(
        serviceNames.configManagerService,
        (c) =>
            new ConfigManagerService(async (config: IAppConfig) => {
                setConfig(config);
                c.get(serviceNames.serviceBusController);

                const businessUnitId = config.businessUnitId as string;
                const configRepository = c.get(serviceNames.configRepository);

                const useCase = new ServiceStartedUseCase(configRepository, businessUnitId, config);
                await useCase.execute();
            })
    );

export const serviceStarter = ServiceManager.startService;
